/* tslint:disable */
/* eslint-disable */
export enum VpnAuthType {
  Certificate = 'CERTIFICATE',
  UsernamePassword = 'USERNAME_PASSWORD'
}
